module.exports = __webpack_public_path__ + "static/media/shopify_plus_img-1.4957f7c1.png";